import { DataLayerEventPayload, DataLayerValue } from './types';

declare global {
  interface Window {
    dataLayer?: DataLayerEventPayload[];
  }
}

export const pushToDataLayer = (dataLayerEvent: DataLayerEventPayload): void => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push(dataLayerEvent);
  }
};

export const sendGaEvent = (eventName: string, payload: Record<string, DataLayerValue> = {}): void => {
  pushToDataLayer({
    event: 'GA_Event',
    eventName,
    ...payload,
  });
};

